import { render, staticRenderFns } from "./PartnersJoin.vue?vue&type=template&id=0a981c33&scoped=true&"
import script from "./PartnersJoin.vue?vue&type=script&lang=js&"
export * from "./PartnersJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a981c33",
  null
  
)

export default component.exports